import React, { Component } from "react";

import { CCard, CCardBody, CCardHeader } from "@coreui/react";
import { connect } from "react-redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";
import Ranking from "../Ranking";
import InterruptorRanking from "../Ranking/Interruptor";

/**
 * RANKING — aba da turma.
 *
 * Para o ALUNO a aba só existe quando o professor liberou o ranking daquela
 * turma (`Show/index.js` consulta o interruptor antes de desenhar o item de
 * menu), e o backend confere de novo: liberação é decisão do servidor, e a
 * aba escondida não é a trava.
 *
 * Para o PROFESSOR a aba existe sempre, liberada ou não — ele precisa ver o
 * ranking para decidir se libera —, e traz o mesmo interruptor do modal
 * aberto pela lista de turmas. São dois caminhos para a mesma decisão porque
 * são dois lugares de onde ele olha a turma; o componente do interruptor é um
 * só, então não há duas verdades sobre o estado.
 *
 * O ERRO NÃO VIRA TOASTR AQUI. A aba inteira é este conteúdo — se ele falhar,
 * o usuário fica olhando um painel vazio e um toast que some em segundos. A
 * mensagem fica no lugar do conteúdo, onde ela ainda estará quando ele
 * procurar o motivo.
 */
class CommunityContentRanking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: null,
      erro: null
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;

    axios
      .get(`${URL.api}gamification/ranking`, {
        params: { room_id: id },
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ data: resp.data.data, loading: false });
      })
      .catch(error => {
        this.setState({
          loading: false,
          erro:
            error.response?.status === 403
              ? "O ranking desta turma não está disponível no momento."
              : "Não foi possível carregar o ranking da turma."
        });
      });
  }

  definirVisibilidade = valor => {
    this.setState(state => ({
      data: { ...state.data, visible_to_students: valor }
    }));
  };

  render() {
    return (
      <CCard>
        <CCardHeader>Ranking da turma</CCardHeader>
        <CCardBody>
          {this.state.loading ? (
            <Loading top="45" left="50" />
          ) : this.state.erro ? (
            <div className="text-muted">{this.state.erro}</div>
          ) : (
            <>
              {this.state.data && this.state.data.can_manage && (
                <InterruptorRanking
                  roomId={this.props.match.params.id}
                  checked={this.state.data.visible_to_students}
                  onChange={this.definirVisibilidade}
                />
              )}
              <Ranking
                data={this.state.data}
                highlightUserId={this.props.user.user.id}
              />
            </>
          )}
        </CCardBody>
      </CCard>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(CommunityContentRanking);
